import { ModalActions } from '../../../actions/user/pharmacy/modal';

const openModal = () => {
  return {
    type: ModalActions.OPEN_MODAL
  };
};
const closeModal = () => {
  return {
    type: ModalActions.CLOSE_MODAL
  };
};

export { openModal, closeModal };
